import { Skeleton } from "@mui/material";
import React from "react";
import useTheme from "../../../../../common/hooks/useTheme";

const HomeSectionSkeleton = ({ selectedTab }: { selectedTab: number }) => {
  const theme = useTheme();
  return (
    <div style={{ width: "100%" }}>
      {selectedTab === 0 ? (
        <div
          style={{
            marginTop: "32px",
            paddingBottom: "32px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Skeleton
            variant="circular"
            sx={{
              width: "107px",
              height: "107px",
              bgcolor: theme.colorTokens.N[30],
            }}
            animation={"pulse"}
          />
          <Skeleton
            variant="circular"
            sx={{
              width: "107px",
              height: "107px",
              bgcolor: theme.colorTokens.N[30],
            }}
            animation={"pulse"}
          />
          <Skeleton
            variant="circular"
            sx={{
              width: "107px",
              height: "107px",
              bgcolor: theme.colorTokens.N[40],
            }}
            animation={"pulse"}
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
            paddingBottom: "32px",
          }}
        >
          <Skeleton
            variant="circular"
            sx={{
              width: "121px",
              height: "121px",
              bgcolor: theme.colorTokens.N[30],
            }}
            animation={"pulse"}
          />
        </div>
      )}
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          height: "80px",
          bgcolor: theme.colorTokens.N[30],
          borderRadius: "8px",
          marginTop: "16px",
        }}
        animation={"pulse"}
      />
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          height: "80px",
          bgcolor: theme.colorTokens.N[30],
          borderRadius: "8px",
          marginTop: "16px",
        }}
        animation={"pulse"}
      />
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          height: "80px",
          bgcolor: theme.colorTokens.N[30],
          borderRadius: "8px",
          marginTop: "16px",
        }}
        animation={"pulse"}
      />
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          height: "80px",
          bgcolor: theme.colorTokens.N[30],
          borderRadius: "8px",
          marginTop: "16px",
        }}
        animation={"pulse"}
      />
    </div>
  );
};

export default HomeSectionSkeleton;
